// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__ZXC81","label":"CategoryService_label__egFs2","location":"CategoryService_location__39hJ5"};